// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"4117a814","252":"a9933738","322":"9a9f1d86","453":"fbf1658e","585":"8e57e09e","967":"18a53e35"}[chunkId] + ".chunk.js";
};